import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations(['SET_CURRENT_FILTER']),
    scrollUpToElement(elm, px, isNavbar) {
      const element = document.querySelector(elm)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
      }
    },

    // waitForElementToExistOnTheDom(selector) {
    //   return new Promise((resolve, reject) => {
    //     let counter = 0
    //     const interval = setInterval(() => {
    //       counter += 1
    //       // i'm, using vanilla isnted of "refs" - refs not shered globaly
    //       const element = document.querySelector(selector)
    //       if (element) {
    //         clearInterval(interval)
    //         resolve(element)
    //       }
    //       // if element not exist in the dom after 2 sec we reject the promise and stop the interval
    //       if (counter >= 20) {
    //         clearInterval(interval)
    //         reject(new Error('Element not found'))
    //       }
    //     }, 100)
    //   })
    // },
  },
}
